// document.addEventListener('DOMContentLoaded', () => {
//   const hamburger = document.querySelector('button.hamburger');
//   const closeBtn = document.querySelector('k-header-drawer__top-content svg');
//   const drawer = document.querySelector('aside.k-header-drawer');

//   if (!hamburger || !closeBtn || !drawer) return;

//   hamburger.addEventListener('click', () => drawer.classList.add('show'));
//   closeBtn.addEventListener('click', () => drawer.classList.remove('show'));
// });
  const drawer = document.querySelector('.k-header-drawer');

  document.querySelector('.hamburger')?.addEventListener('click', () => {
    drawer?.classList.add('show');
  });

  document.querySelector('.k-header-drawer__close-icon')?.addEventListener('click', () => {
    drawer?.classList.remove('show');
  });